import { render, staticRenderFns } from "./SidebarStyle1.vue?vue&type=template&id=24bff734"
import script from "./SidebarStyle1.vue?vue&type=script&lang=js"
export * from "./SidebarStyle1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports